export default "__VITE_ASSET__disYo6Xq__"